import { MarkEmailReadOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ksim from '../assets/ksim-console2.png';
import AccountLayout from '../layouts/AccountLayout';

const RegistrationConfirmation = () => {
  const [params] = useSearchParams('email');
  const email = params.get('email');

  return (
    <AccountLayout sx={{ alignItems: 'center' }}>
      <Box mt={{ xs: 4, sm: 14 }} mb={4.5}>
        <Box component="img" alt="K-Sim" height={192} src={ksim} />
      </Box>
      <Typography variant="h5" mb={2}>
        Create an account
      </Typography>

      <MarkEmailReadOutlined sx={{ color: 'primary.light', fontSize: 84, mb: 2.5 }} />
      <Typography variant="h6">
        A verification email has been sent to{' '}
        <Typography component="span" color="text.secondary">
          {email}
        </Typography>
      </Typography>
      <Typography>Please follow the instructions in the email.</Typography>
    </AccountLayout>
  );
};

export default RegistrationConfirmation;
